import { render, staticRenderFns } from "./FormAtestado.vue?vue&type=template&id=641683fe&"
import script from "./FormAtestado.vue?vue&type=script&lang=js&"
export * from "./FormAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports